import useEventThemeBase from '@bottlebooks/gatsby-theme-cms/src/@bottlebooks/gatsby-theme-event/components/Layout/useEventTheme';
export default function useEventTheme() {
  const theme = useEventThemeBase();
  // Colors are hard-coded in theme.
  const { colors, ...rest } = theme;
  return rest;
}
